import { BeatLoader } from 'react-spinners';
import clsx from 'clsx';
import spinning from '../spinning.svg';
import FidelityCardTile from '../../../account/fid/FidelityCardTile';
import pikkoLookingTheTop from '../pikkoLookingTheTop.svg';
import { useEffect, useState } from 'react';

export const LoadingCreationFidCard = ({ isLoading, cardData }) => {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setMounted(true);
        }, 50);
        return () => clearTimeout(timer);
    }, []);

    return (
        <div className={clsx("flex flex-col z-[8000] items-center gap-2 h-[100dvh] w-[100dvw] fixed top-0 left-0 right-0 bottom-0 bg-gradient4 transition-transform duration-500 ease-out", {
            "translate-x-full": !mounted,
            "translate-x-0": mounted
        })}>
            {/* Spinner - visible during the creation */}
            <div className={clsx('fixed top-1/3 left-1/2 transform -translate-x-1/2 -translate-y-1/2 transition-all duration-700', {
                'opacity-100 scale-100': !isLoading,
                'opacity-0 scale-0': isLoading
            })}>
                <img
                    src={spinning}
                    className="animate-spin"
                    style={{
                        animation: 'spin 30s linear infinite'
                    }}
                    alt=""
                />
            </div>

            {/*Text for loading */}
            <div className={clsx('flex transition-all duration-[1000ms] flex-col gap-24 w-full items-center absolute top-1/2 left-1/2 transform -translate-x-1/2', {
                'opacity-100 scale-100 -translate-y-1/2': isLoading,
                'opacity-0 scale-50 translate-y-0': !isLoading
            })}>
                <p className='text-6xl max-w-[240px] w-full geomanistMedium text-center'>
                    Ta carte est en cours de création
                </p>
                <BeatLoader color="#000" size={20} className="mt-8" />
            </div>

            {/* Fidelity Card Display - visible after the creation */}
            <div className={clsx('flex flex-col items-center justify-center absolute top-1/3 left-1/2 transform -translate-x-1/2 -translate-y-1/2 transition-all duration-[1500ms] -rotate-6', {
                'opacity-0 scale-50': isLoading,
                'opacity-100 scale-100': !isLoading
            })}>
                {cardData && (
                    <div className="relative flex flex-col items-center">

                        <FidelityCardTile
                            img={cardData.cardImage}
                            logo={cardData.companyLogo}
                            name={cardData.name}
                            surname={cardData.surname}
                            numero={cardData.numero}
                        />

                    </div>
                )}
            </div>
            <img className={clsx('fixed bottom-0 left-1/2 transition-all duration-[1000ms] transform -translate-x-1/2', {
                'bottom-0': !isLoading,
                'bottom-[-70px]': isLoading
            })} src={pikkoLookingTheTop} alt="pikko" />
        </div>
    );
}